const BANNER_CONTENT_LANGS = ['ko', 'en', 'ja']

const BANNER_CONTENT_DEFAULTS = {
  CX: {
    ko: {
      title: 'CX Data Trend',
      label: 'Benchmark Big Data'
    },
    en: {
      title: 'CX Data Trend',
      label: 'Benchmark Big Data'
    },
    ja: {
      title: 'CX Data Trend',
      label: 'Benchmark Big Data'
    }
  },
  GEO: {
    ko: {
      title: 'GEO 월간백서'
    },
    en: {
      title: 'GEO White Paper'
    },
    ja: {
      title: 'GEO ホワイトペーパー'
    }
  },
  BLOG: {
    ko: {
      title: 'UX · GEO · AI 인사이트'
    },
    en: {
      title: 'UX · GEO · AI Insight'
    },
    ja: {
      title: 'UX · GEO · AI インサイト'
    }
  }
}

const getBannerContentDefaults = (bannerType, lang) => {
  const contentDefault = (BANNER_CONTENT_DEFAULTS[bannerType] || {})[lang] || {}
  return {
    title: contentDefault.title || '',
    label: contentDefault.label || ''
  }
}

const createBannerContent = (lang, bannerType = '') => {
  const contentDefault = getBannerContentDefaults(bannerType, lang)
  return {
    lang,
    imageUrl: '',
    title: contentDefault.title,
    label: contentDefault.label,
    text: '',
    linkUrl: ''
  }
}

const normalizeBannerContent = (content = {}, bannerType = '') => {
  const contentDefault = getBannerContentDefaults(bannerType, content.lang)
  const title = content.title || contentDefault.title
  const label = content.label || contentDefault.label
  return {
    lang: content.lang,
    imageUrl: content.imageUrl || '',
    title,
    label,
    text: content.text || '',
    linkUrl: content.linkUrl || ''
  }
}

module.exports = {
  BANNER_CONTENT_LANGS,
  createBannerContent,
  getBannerContentDefaults,
  normalizeBannerContent
}
